"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconPowerToGas = function IconPowerToGas(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m23.88 4.383-1.21 1.544-.641.838-.468.618a145 145 0 0 0-3.366 4.654 100 100 0 0 0-1.726 2.582c-3.982 6.22-6.009 10.94-6.009 14.171C10.47 36.632 16.446 43 23.88 43c7.438 0 13.42-6.372 13.42-14.21 0-3.147-1.933-7.726-5.717-13.713l-.292-.458q-.269-.417-.555-.851-.557-.842-1.17-1.73a140 140 0 0 0-2.68-3.734l-.925-1.236-1.295-1.686zm5.187 10.487.54.827.287.451c3.594 5.686 5.406 9.979 5.406 12.642C35.3 35.55 30.184 41 23.88 41c-6.3 0-11.41-5.446-11.42-12.211 0-2.74 1.904-7.173 5.692-13.09q.261-.405.54-.829.546-.824 1.148-1.695a138 138 0 0 1 2.64-3.68l.914-1.22.486-.64.72.95a143 143 0 0 1 3.32 4.59q.604.87 1.147 1.695M25 12.52l-3.88 7.76h1.94v5.82L27 18.34h-2zm3.68 21.92a3.25 3.25 0 0 0 3.24-3.26 3.14 3.14 0 0 0-3.26-3.24 3.25 3.25 0 0 0 .02 6.5M22 34.29v-6.22h-1.13v2.41h-2.95v-2.41h-1.14v6.22h1.14v-2.73h2.95v2.73zm4.65-3.11a2 2 0 1 0 2-2.08 2 2 0 0 0-1.99 2.08zm-2.59 3.67-1.16 1v.83h2.68v-.91h-1.32l.61-.51a1.48 1.48 0 0 0 .67-1.17c0-.67-.49-1.09-1.33-1.09a1.21 1.21 0 0 0-1.39 1.31h1a.34.34 0 0 1 .36-.38.28.28 0 0 1 .31.29c0 .242-.205.427-.409.61z",
    clipRule: "evenodd"
  })));
};

export { IconPowerToGas, IconPowerToGas as default };
